// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".List-group-2yWAk {\n  padding-left: 0;\n  margin: 0;\n}\n.List-liReset-3qhnu {\n  list-style-type: none;\n  margin: 0;\n}\n.List-navContainer-395-s {\n  position: relative;\n  display: grid;\n}\n", ""]);
// Exports
exports.locals = {
	"group": "List-group-2yWAk",
	"liReset": "List-liReset-3qhnu",
	"navContainer": "List-navContainer-395-s"
};
module.exports = exports;
